export const selectCurrentPlayer = (state) => state.currentPlayer;
